export const searchEnabler = () => {
   let submitBtn = document.querySelectorAll(".searchsubmit");

   let iconSearch = document.querySelector(".searchsubmit-search");
   let iconCross = document.querySelector(".searchsubmit-x");

   let searchInput = document.querySelector(".searchinput");
   let close = false;
   submitBtn.forEach(item=>{
        item.addEventListener("click",()=>{
            searchInput.classList.toggle("searchinput--visible");
            if(close == false) {
                close=true;
                iconSearch.style.display="none";
                iconCross.style.display="block";
            }
            else {
                close=false;
                iconSearch.style.display="block";
                iconCross.style.display="none";
            }
        })
   })

   let submitBtnMobile = document.querySelectorAll(".searchsubmit-mobile");

   let iconSearchMobile = document.querySelector(".searchsubmit-search-mobile");
   let iconCrossMobile = document.querySelector(".searchsubmit-x-mobile");

   let searchInputMobile = document.querySelector(".searchinput-mobile");
   let closeMobile = false;
   submitBtnMobile.forEach(item=>{
        item.addEventListener("click",()=>{
            searchInputMobile.classList.toggle("searchinput-mobile--visible");
            if(closeMobile == false) {
                closeMobile=true;
                iconSearchMobile.style.display="none";
                iconCrossMobile.style.display="block";
            }
            else {
                closeMobile=false;
                iconSearchMobile.style.display="block";
                iconCrossMobile.style.display="none";
            }
        })
   })
}
